export default "__VITE_ASSET__BlfKi2P7__"